module.exports = __webpack_public_path__ + "img/yezhupan.9dd1a19f.svg";